import type { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';

import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import useMessageRequestBehavior from 'common/components/CopyMagic/hooks/useMessageRequestBehavior';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';

const useSubmitPromptSetNewMessages = () => {
  const {
    promptValues: initialValues,
    setPromptValues,
    resetPromptValues,
  } = useUiResourceContext();
  const { requestAndSetNewMessages } = useMessageRequestBehavior();
  const trackOnGenerate = useGeneratorTrackingCallback('useTrackOnGenerate');

  const submitPrompt = async (promptValues: PromptFormValuesType) => {
    setPromptValues(promptValues);
    trackOnGenerate({ promptValues });
    const responseData = await requestAndSetNewMessages([
      {
        role: MESSAGE_DATA_ROLES.USER,
        content: promptValues.topic,
      },
    ]);

    if (responseData) {
      resetPromptValues();
    }
  };

  return {
    initialValues,
    submitPrompt,
  };
};

export default useSubmitPromptSetNewMessages;
